import React, { useContext, useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

import { ModaisColetaDomiciliarContext } from "../../../Context/ModaisColetaDomiciarContext";
import { api } from "../../../../../services/Api";

function normalizarResposta(data) {
  if (Array.isArray(data)) {
    return data;
  }

  if (Array.isArray(data?.data)) {
    return data.data;
  }

  if (Array.isArray(data?.logs)) {
    return data.logs;
  }

  if (Array.isArray(data?.coletaLogs)) {
    return data.coletaLogs;
  }

  if (Array.isArray(data?.resultado)) {
    return data.resultado;
  }

  return [];
}

export default function ModalHistorico({ codigo_pedido, posto_pedido }) {
  const { enqueueSnackbar } = useSnackbar();
  const { modalHistorico, setModalHistorico } = useContext(
    ModaisColetaDomiciliarContext
  );

  const [historico, setHistorico] = useState([]);
  const [loading, setLoading] = useState(false);

  const pedido =
    codigo_pedido && posto_pedido
      ? `${codigo_pedido}-${posto_pedido}`
      : "";

  function formatarDataHora(valor) {
    if (!valor) {
      return "Data não informada";
    }

    const data = new Date(valor);

    if (Number.isNaN(data.getTime())) {
      return String(valor);
    }

    return data.toLocaleString("pt-BR");
  }

  useEffect(() => {
    async function carregarHistorico() {
      if (!pedido) {
        setHistorico([]);
        return;
      }

      try {
        setLoading(true);

        const { data } = await api.get("/v2/coleta/coletaLog", {
          params: {
            pedido,
            limit: 50,
          },
        });

        setHistorico(normalizarResposta(data));
      } catch (error) {
        setHistorico([]);
        enqueueSnackbar("Falha ao carregar histórico", { variant: "error" });
      } finally {
        setLoading(false);
      }
    }

    if (modalHistorico) {
      carregarHistorico();
    }
  }, [enqueueSnackbar, modalHistorico, pedido]);

  return (
    <Dialog
      open={modalHistorico}
      onClose={() => setModalHistorico(false)}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle sx={{ color: "text.primary" }}>Historico</DialogTitle>
      <DialogContent dividers sx={{ color: "text.primary" }}>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Pedido: {pedido || "Não informado"}
          </Typography>
        </Box>

        {loading && (
          <Box
            sx={{
              py: 4,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress size={28} />
          </Box>
        )}

        {!loading && historico.length === 0 && (
          <Typography variant="body2" color="text.primary">
            Sem histórico para exibir.
          </Typography>
        )}

        {!loading && historico.length > 0 && (
          <Box sx={{ mt: 1 }}>
            {historico.map((item, index) => {
              const identificador =
                item.id || item._id || `${item.usuario || "usuario"}-${index}`;

              return (
                <Box
                  key={identificador}
                  sx={{
                    display: "flex",
                    alignItems: "stretch",
                    gap: 2,
                    pb: index < historico.length - 1 ? 2.5 : 0,
                  }}
                >
                  <Box
                    sx={{
                      width: 20,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        bgcolor: "primary.main",
                        mt: 0.6,
                        flexShrink: 0,
                      }}
                    />
                    {index < historico.length - 1 && (
                      <Box
                        sx={{
                          mt: 0.5,
                          width: 2,
                          flex: 1,
                          bgcolor: "divider",
                          minHeight: 36,
                        }}
                      />
                    )}
                  </Box>

                  <Box
                    sx={{
                      flex: 1,
                      bgcolor: "background.paper",
                      color: "text.primary",
                      border: 1,
                      borderColor: "divider",
                      borderRadius: 1,
                      px: 1.5,
                      py: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        gap: 0.75,
                        flexWrap: "wrap",
                      }}
                    >
                         <Typography variant="caption" color="text.secondary">
                        {item.usuario || "Não informado"}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {formatarDataHora(
                          item.criado_em ||
                            item.createdAt ||
                            item.data_criacao ||
                            item.data
                        )}
                      </Typography>
                     
                    </Box>
                    <Typography variant="body2" color="text.primary" sx={{ mt: 0.5 }}>
                      {item.acao || "Ação não informada"}
                    </Typography>
                  </Box>
                </Box>
              );
            })}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setModalHistorico(false)}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}